import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c6ad63bbef1ba6267d3dd941b2aa6582.jpg"
          alt="Premium legal representation - Gosfield &amp; Associates courtroom setting"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1628]/95 via-[#0A1628]/80 to-[#0A1628]/35" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/70 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pt-28 pb-20">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2.5 mb-8 px-4 py-2 border border-[#C9A961]/40 rounded-full bg-[#C9A961]/8 backdrop-blur-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-[#C9A961] animate-pulse flex-shrink-0" />
            <span className="text-[11px] tracking-[0.18em] text-[#C9A961] uppercase font-inter font-medium">
              Boutique Health Law Firm &mdash; Philadelphia, PA &mdash; Est. 1986
            </span>
          </div>

          <h1 className="text-5xl lg:text-[68px] font-playfair font-bold text-white leading-[1.06] mb-6">
            Strategic Legal<br />
            <em className="italic text-[#C9A961] not-italic" style={{ fontStyle: "italic" }}>Representation</em><br />
            When It Matters Most
          </h1>

          <p className="text-lg lg:text-xl text-slate-300 font-inter font-light leading-relaxed mb-10 max-w-lg">
            Protect your rights, resolve disputes, and move forward with confidence through
            experienced health law counsel trusted by physicians and health systems nationwide.
          </p>

          {/* Primary CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-14">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2.5 bg-[#C9A961] hover:bg-[#b8954f] text-[#0A1628] font-inter font-bold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
            >
              <i className="ri-calendar-check-line" />
              Schedule Consultation
            </Link>
            <a
              href="tel:+12157352384"
              className="inline-flex items-center justify-center gap-2.5 border border-white/35 hover:border-[#C9A961] text-white hover:text-[#C9A961] font-inter font-medium px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-base backdrop-blur-sm"
            >
              <i className="ri-phone-line text-[#C9A961]" />
              Call Now: (215) 735-2384
            </a>
          </div>

          {/* Trust micro stats */}
          <div className="flex flex-wrap gap-8">
            {[
              { stat: "Est. 1986", desc: "Decades of Experience" },
              { stat: "50 States", desc: "National Practice" },
              { stat: "Top 5", desc: "Best Law Firm 2024" },
            ].map((item) => (
              <div key={item.stat} className="flex items-center gap-3">
                <div className="w-0.5 h-10 bg-[#C9A961]" />
                <div>
                  <div className="text-white font-playfair font-bold text-xl leading-none">
                    {item.stat}
                  </div>
                  <div className="text-slate-400 text-xs font-inter mt-0.5">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right side floating card — above fold lead capture */}
      <div className="absolute right-8 lg:right-16 top-1/2 -translate-y-1/2 hidden xl:block">
        <div className="bg-white/95 backdrop-blur-md rounded-2xl p-6 w-64 border border-white/60">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-7 h-7 flex items-center justify-center rounded-full bg-[#0A1628]">
              <i className="ri-shield-check-line text-[#C9A961] text-sm" />
            </span>
            <span className="text-xs font-inter font-bold text-[#0A1628] uppercase tracking-wide">
              Free Consultation
            </span>
          </div>
          <p className="text-slate-600 text-xs font-inter leading-relaxed mb-4">
            Speak directly with our experienced health law attorneys — no obligation.
          </p>
          <div className="flex flex-col gap-2.5">
            <a
              href="tel:+12157352384"
              className="flex items-center gap-2 py-2.5 px-3 rounded-lg bg-[#0A1628] text-white text-xs font-inter font-semibold hover:bg-[#152238] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-[#C9A961]" />
              (215) 735-2384
            </a>
            <Link
              to="/contact"
              className="flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg bg-[#C9A961] text-[#0A1628] text-xs font-inter font-bold hover:bg-[#b8954f] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line" />
              Book Online
            </Link>
          </div>
          <p className="mt-3 text-center text-[10px] text-slate-400 font-inter">
            Mon–Fri &bull; 9 AM – 5:30 PM ET
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1.5 animate-bounce">
        <span className="text-[9px] tracking-[0.25em] text-slate-500 uppercase font-inter">Scroll</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-[#C9A961]" />
        </div>
      </div>
    </section>
  );
}
